export default __webpack_public_path__ + "static/wifi_w.6b704b5536ed45f303c33e5c032a19ea.png";